export const isPointInPolygon = (point, polygon) => {
  // Implementation of point-in-polygon algorithm
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].lat,
      yi = polygon[i].lng;
    const xj = polygon[j].lat,
      yj = polygon[j].lng;

    const intersect =
      yi > point.lng !== yj > point.lng &&
      point.lat < ((xj - xi) * (point.lng - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
};

export const isPolygonInPolygon = (innerPolygon, outerPolygon) => {
  // Check if all points of inner polygon are inside outer polygon
  return innerPolygon.every((point) => isPointInPolygon(point, outerPolygon));
};
